import cn from './cn.js';

/** Shimmering placeholder. Pass width/height via className or style. */
export default function Skeleton({ className, style, circle = false, ...props }) {
  return (
    <span
      aria-hidden="true"
      className={cn('ex-skeleton block', circle ? 'rounded-full' : 'rounded-md', className)}
      style={style}
      {...props}
    />
  );
}

export function SkeletonText({ lines = 3, className }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="h-3.5" style={{ width: i === lines - 1 ? '60%' : '100%' }} />
      ))}
    </div>
  );
}
